import React from 'react';
import './App.css';
import { captureShareAttribution } from './services/attribution';
import { ensureReferralCode } from './services/referral';
captureShareAttribution();
ensureReferralCode();
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

const LegacyTyresRedirect = () => { const { search } = useLocation(); return <Navigate to={`/pieces/pneus-jantes-et-accessoires${search}`} replace />; };
import Header from './components/Header';
import VehicleSelector from './components/VehicleSelector';
import RecentVehicles from './components/RecentVehicles';
import BannerCarousel from './components/BannerCarousel';
import ImpersonationBanner from './components/ImpersonationBanner';
import CategoryGrid from './components/CategoryGrid';
import AccessoriesSection from './components/AccessoriesSection';
import TrustBadges from './components/TrustBadges';
import ReviewsWall from './components/ReviewsWall';
import BestSellers from './components/BestSellers';
import CarBrandsSection from './components/CarBrandsSection';
import HomeTopModels from './components/HomeTopModels';
import ManufacturersSection from './components/ManufacturersSection';
import ArticlesSection from './components/ArticlesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import WhatsAppButton from './components/WhatsAppButton';
import GoogleRatingBadge from './components/GoogleRatingBadge';

// Pages
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ArticlePage from './pages/ArticlePage';
import ArticlesListPage from './pages/ArticlesListPage';
import AdminPage from './pages/AdminPage';
import CategoryPage from './pages/CategoryPage';
import VehicleBrandsPage from './pages/VehicleBrandsPage';
import VehicleBrandPage from './pages/VehicleBrandPage';
import VehicleModelPage from './pages/VehicleModelPage';
import TyresWheelsPage from './pages/TyresWheelsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import FittingAppointmentPage from './pages/FittingAppointmentPage';
import FittingCentreSchedulePage from './pages/FittingCentreSchedulePage';
import AccountantPortalPage from './pages/AccountantPortalPage';
import InvoiceVerifyPage from './pages/InvoiceVerifyPage';
import FittingReviewPage from './pages/FittingReviewPage';
import OrdersPage from './pages/OrdersPage';
import MpOrderDetailPage from './pages/MpOrderDetailPage';
import PaymentLinkPage from './pages/PaymentLinkPage';
import PaymentReturnPage from './pages/PaymentReturnPage';
import PartsPage from './pages/PartsPage';
import SearchPage from './pages/SearchPage';
import BrandPage from './pages/BrandPage';
import BrandsPage from './pages/BrandsPage';
import ContentPage from './pages/ContentPage';
import RecentlyViewed from './components/RecentlyViewed';
import { Toaster } from './components/ui/sonner';
import CookieBanner from './components/CookieBanner';
import WishlistPage from './pages/WishlistPage';
import ProductPage from './pages/ProductPage';
import AccountPage from './pages/AccountPage';
import ComparePage from './pages/ComparePage';
import CompareModelsPage from './pages/CompareModelsPage';
import BudgetRankingPage from './pages/BudgetRankingPage';
import KmUpdatePage from './pages/KmUpdatePage';
import CompareBar from './components/CompareBar';
import UsedPartsPage, { UsedPartPage } from './pages/UsedPartsPage';
import CartDrawer from './components/CartDrawer';
import VehicleSync from './components/VehicleSync';
import ScrollToTop from './components/ScrollToTop';
import ServerErrorScreen from './components/ServerErrorScreen';
import NotFoundPage from './pages/NotFoundPage';
import ContactPage from './pages/ContactPage';
import ShippingPage from './pages/ShippingPage';
import ReturnsPage from './pages/ReturnsPage';
import AboutPage from './pages/AboutPage';
import SitemapPage from './pages/SitemapPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { usePageMeta } from './services/seo';
import { useT } from './services/i18n';
import HomeHero from './components/HomeHero';
import HomeFaq from './components/HomeFaq';
import NewProductsPage from './pages/NewProductsPage';
import HomeNewArrivals from './components/HomeNewArrivals';

const Home = () => {
  const { t } = useT();
  usePageMeta({ path: '/', rawTitle: t('home.seoTitle'), description: t('home.seoDesc'), keywords: t('home.seoKeywords').split(',').map((k) => k.trim()) });
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HomeHero />
        <VehicleSelector />
        <RecentVehicles />
        <BannerCarousel />
        <CategoryGrid />
        <AccessoriesSection />
        <TrustBadges />
        <ReviewsWall />
        <BestSellers />
        <HomeNewArrivals />
        <RecentlyViewed variant="home" />
        <CarBrandsSection />
        <HomeTopModels />
        <ManufacturersSection />
        <ArticlesSection />
        <HomeFaq />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ImpersonationBanner />
        <ServerErrorScreen />
        <ChatWidget />
        <WhatsAppButton />
        <GoogleRatingBadge />
        <CompareBar />
        <CartDrawer />
        <VehicleSync />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inscription" element={<RegisterPage />} />
          <Route path="/nouveautes" element={<NewProductsPage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
          <Route path="/reinitialiser-mot-de-passe" element={<ResetPasswordPage />} />
          <Route path="/articles" element={<ArticlesListPage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/categorie/:slug" element={<CategoryPage />} />
          <Route path="/pieces/pneus-jantes-et-accessoires" element={<TyresWheelsPage />} />
          <Route path="/pieces/pneus-et-jantes" element={<LegacyTyresRedirect />} />
          <Route path="/montage/centre/:token" element={<FittingCentreSchedulePage />} />
          <Route path="/comptable/:token" element={<AccountantPortalPage />} />
          <Route path="/verification-facture/:number/:code" element={<InvoiceVerifyPage />} />
          <Route path="/montage/avis/:token" element={<FittingReviewPage />} />
          <Route path="/montage/:token" element={<FittingAppointmentPage />} />
          <Route path="/pieces/:slug" element={<CategoryPage />} />
          <Route path="/pieces/:slug/:sub" element={<CategoryPage />} />
          <Route path="/pieces/:slug/:sub/:subsub" element={<CategoryPage />} />
          <Route path="/panier" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/mes-commandes" element={<OrdersPage />} />
          <Route path="/mes-commandes/occasion/:id" element={<MpOrderDetailPage />} />
          <Route path="/payer/:token" element={<PaymentLinkPage />} />
          <Route path="/paiement/retour" element={<PaymentReturnPage />} />
          <Route path="/pieces" element={<PartsPage />} />
          <Route path="/recherche" element={<SearchPage />} />
          <Route path="/marque/:name" element={<BrandPage />} />
          <Route path="/marques" element={<BrandsPage />} />
          <Route path="/vehicules" element={<VehicleBrandsPage />} />
          <Route path="/vehicules/:slug" element={<VehicleBrandPage />} />
          <Route path="/vehicules/:slug/:modelSlug" element={<VehicleModelPage />} />
          <Route path="/page/:slug" element={<ContentPage />} />
          <Route path="/liste-de-souhaits" element={<WishlistPage />} />
          <Route path="/produit/:id" element={<ProductPage />} />
          <Route path="/mon-compte/*" element={<AccountPage />} />
          <Route path="/comparaison" element={<ComparePage />} />
          <Route path="/occasion" element={<UsedPartsPage />} />
          <Route path="/occasion/:ref" element={<UsedPartPage />} />
          <Route path="/comparaison-modeles" element={<CompareModelsPage />} />
          <Route path="/budget-entretien" element={<BudgetRankingPage />} />
          <Route path="/km/:token" element={<KmUpdatePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/livraison" element={<ShippingPage />} />
          <Route path="/garantie-retours" element={<ReturnsPage />} />
          <Route path="/qui-sommes-nous" element={<AboutPage />} />
          <Route path="/plan-du-site" element={<SitemapPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors closeButton />
      <CookieBanner />
    </div>
  );
}

export default App;
